import noWorkoutsImage from '../../../asset/image/no-workouts.png'
import React from 'react'
import { Link } from 'react-router-dom'
import { OutlinedButton } from 'src/component/ui/button'

export const NoFavorites = (): React.ReactElement => {
  return (
    <div>
      <p className="font-roboto-condensed-medium text-ivory">No favorites found, please explore our list of workouts!</p>
      <div className="relative flex items-center justify-center min-h-[270px] w-full overflow-hidden rounded-md">
        <img src={noWorkoutsImage} alt="" className="absolute inset-0 w-full h-full object-cover z-0" />
        <OutlinedButton asChild className="relative z-10 border-ivory text-ivory">
          <Link to="/workouts">SEE ALL WORKOUTS</Link>
        </OutlinedButton>
      </div>
    </div>
  )
}
